import { createContext } from '../utils/create-context';
import type { ThemeColors } from './component-vars.css';

export type ThemeMode = 'light' | 'dark';

export const [ThemeModeProvider, useThemeMode] =
  createContext<ThemeMode>('ThemeModeProvider');

export const [ThemeSwitchProvider, useThemeSwitch] = createContext<
  (theme: ThemeMode) => void
>('ThemeSwitchProvider');

export const [ThemeColorsProvider, useThemeColors] = createContext<ThemeColors>(
  'ThemeColorsProvider',
);
